export * from './resultsStatus.scale';
export * from './symbolsScale';
export * from './taskResult.scale';